import { useInventoryTurnoverRoutes } from "./routes";
import { GetDefaultIndex } from "../../components";
import { useGetInventoryTurnoverCommonInfoQuery } from "../../features/api/inventoryTurnoverApi";

export { useInventoryTurnoverRoutes };

interface IInventoryTurnoversProps {
  isEstimated: boolean;
}

const InventoryTurnovers = ({ isEstimated }: IInventoryTurnoversProps) => {
  let title = isEstimated ? "گردش موجودی کالا (برآوردی)" : "گردش موجودی کالا";

  return GetDefaultIndex({
    title: title,
    query: useGetInventoryTurnoverCommonInfoQuery,
    queryArgs: isEstimated,
  })();
};

export default InventoryTurnovers;
